/**
 * Email-gated page Klaviyo form behavior:
 * - Hides close control and blocks Escape pre-submit (via CSS + keydown)
 * - Inerts main content pre-submit to block keyboard access to collection
 * - Provides screen reader instructions via aria-describedby on the Klaviyo dialog
 */
(function () {
  if (!document.body.classList.contains('email-gated')) {
    return;
  }

  const INSTRUCTIONS_ID = 'email-gate-sr-instructions';
  const MESSAGES = {
    active:
      'Enter your email address to access this page. This dialog cannot be closed until you submit the form.',
    submitted: 'Thank you. You may now close this dialog.',
  };

  let klaviyoGateFormOpen = false;
  let instructionsEl = null;

  function getSiteContainer() {
    return document.querySelector('[data-site-container]');
  }

  function setBackgroundInert(inert) {
    const siteContainer = getSiteContainer();

    if (siteContainer) {
      siteContainer.inert = inert;
    }
  }

  function getInstructionsEl() {
    if (!instructionsEl) {
      instructionsEl = document.createElement('div');
      instructionsEl.id = INSTRUCTIONS_ID;
      instructionsEl.className = 'visually-hidden';
      document.body.appendChild(instructionsEl);
    }

    return instructionsEl;
  }

  function getKlaviyoDialog() {
    const form = document.querySelector('.klaviyo-form, [data-testid^="klaviyo-form-"]');

    return form?.closest('[role="dialog"]') ?? null;
  }

  function setScreenReaderInstructions(state) {
    const dialog = getKlaviyoDialog();

    if (!dialog) {
      return false;
    }

    const el = getInstructionsEl();
    el.textContent = MESSAGES[state] || MESSAGES.active;
    dialog.setAttribute('aria-describedby', INSTRUCTIONS_ID);

    return true;
  }

  function whenDialogReady(state, attemptsLeft = 10) {
    if (setScreenReaderInstructions(state)) {
      return;
    }

    if (attemptsLeft <= 0) {
      return;
    }

    requestAnimationFrame(() => whenDialogReady(state, attemptsLeft - 1));
  }

  function clearScreenReaderInstructions() {
    const dialog = getKlaviyoDialog();

    if (dialog) {
      dialog.removeAttribute('aria-describedby');
    }

    if (instructionsEl) {
      instructionsEl.textContent = '';
    }
  }

  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail;

    if (!detail || !detail.type) {
      return;
    }

    switch (detail.type) {
      case 'open':
        document.body.classList.remove('email-gated-form-submitted');
        document.body.classList.add('email-gated-form-active');
        klaviyoGateFormOpen = true;
        setBackgroundInert(true);
        whenDialogReady('active');
        break;
      case 'submit':
        document.body.classList.remove('email-gated-form-active');
        document.body.classList.add('email-gated-form-submitted');
        klaviyoGateFormOpen = false;
        setBackgroundInert(false);
        setScreenReaderInstructions('submitted');
        break;
      case 'close':
      case 'redirectedToUrl':
        document.body.classList.remove('email-gated-form-active', 'email-gated-form-submitted');
        klaviyoGateFormOpen = false;
        setBackgroundInert(false);
        clearScreenReaderInstructions();
        break;
    }
  });

  document.addEventListener(
    'keydown',
    (event) => {
      if (!klaviyoGateFormOpen || event.key !== 'Escape') {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
})();
